import { ReqEnum } from '../const/requestStatus';
import Fetch from '../utils/fetch';
import { settings } from '../settings';
import { HubSortListEntry } from '../hooks/useFetchHubSortList';
import Swal from 'sweetalert2';
import { ISortListBundle } from 'pages/NewSortList/SortListBundle';
import { AllBundlesResponse } from './fetchHubSortListEntriesAll';

export async function fetchHubSortListEntries(
  bundleIds: string[]
): Promise<[HubSortListEntry[], ReqEnum]> {
  const response = await Fetch.post({
    url: `${settings.newApiUrl}/hubsort/bundles`,
    body: {
      bundleIds,
    },
  });
  if (response.ok) {
    const hubSortListEntries = (await response.json()) as HubSortListEntry[];
    return [hubSortListEntries, ReqEnum.SUCCESS];
  } else {
    return [[], ReqEnum.ERROR];
  }
}

export const fetchSortListBundle = async (
  bundleId: number
): Promise<ISortListBundle | null> => {
  const response = await Fetch.get({
    url: `${settings.newApiUrl}/hubsort/bundle/${bundleId}`,
  });

  if (response.ok) {
    return (await response.json()) as ISortListBundle;
  } else {
    return null;
  }
};

export const fetchSortListBundles = async (
  bundleIds: string[]
): Promise<AllBundlesResponse | undefined> => {
  const response = await Fetch.post({
    url: `${settings.newApiUrl}/hubsort/bundles/v2`,
    body: {
      bundleIds,
    },
  });
  if (response.ok) {
    return (await response.json()) as AllBundlesResponse;
  } else {
    return undefined;
  }
};

export const updatePackagesNumber = async (
  orderId: string,
  packagesNumber: number
): Promise<boolean> => {
  try {
    const response = await Fetch.put({
      url: `${settings.newApiUrl}/order/${orderId}/set-package-number/${packagesNumber}`,
      body: {},
    });

    if (response.ok) {
      Swal.fire({
        position: 'center',
        icon: 'success',
        title: 'Nr of parcels is updated',
        showConfirmButton: false,
        timer: 1500,
      });
      return true;
    }
  } catch (error) {
    Swal.fire({
      position: 'center',
      icon: 'error',
      title: 'There was an error, try again',
      showConfirmButton: false,
      timer: 1500,
    });
    return false;
  }
  return false;
};
